import { OdsPriorityGroups } from '../../../interfaces/ODSPriorityGroups';
import ResponsiveContainer from '../../../layouts/ResponsiveContainer';
import SelectableCardList from './SelectableCardList';
import CustomSelects from '../../Inputs/Selects/CustomSelect';
import { Period } from '../../../interfaces/Periods';

interface IGoalSelector {
    data: OdsPriorityGroups[];
    periods: Period[];
    handlePeriod: (period: string) => void;
    handleSelect: (id: number) => void;
    selectedId: number | null;
    selectedPeriod: string | null;
    isMobile: boolean;
    module: string;
}

const GoalSelector = ({ data, periods, handlePeriod, handleSelect, selectedId, selectedPeriod, isMobile, module }: IGoalSelector) => {

    return (
        <section className="flex flex-col items-center mt-1 xl:mt-6 mb-8 relative w-full">
            <div className='flex flex-col items-end w-full mt-8 md:mt-0'>
                <CustomSelects
                    options={periods ?? []}
                    onSelect={handlePeriod}
                    selectedItem={`Período ${selectedPeriod}`}
                    defaultSelectedItem={`Período ${selectedPeriod}`}
                    label=''
                    showLabel={false}
                    className='w-full !justify-center sm:min-w-[175px] sm:max-w-[175px]'
                />
                <SelectableCardList
                    items={data}
                    selectedId={selectedId ?? undefined}
                    onSelect={handleSelect}
                    isMobile={isMobile}
                    module={module}
                />
            </div>
        </section>
    );
};

export default GoalSelector;